<template>
  <div>
    <chart :content="content" />
  </div>
</template>

<script>
  import Chart from '../../Charts/Chart'

  export default {
    name: 'SubChart',
    components: {
      Chart
    },
    props: {
      content:{
        type: Object,
        required: true
      }
    }
  }
</script>
